import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {NGXLogger} from 'ngx-logger';
import {GroupService} from '../../../../../_services/group.service';
import {SiteGroup} from '../../../../../_models/group.model';
import {Subscription} from 'rxjs';

@Component({
    selector: 'acabim-admin-groups-site-update',
    templateUrl: './update-site-group.component.html'
})
export class GroupSiteUpdateComponent implements OnInit, OnDestroy {

    @Input() public siteDetails: SiteGroup = {
        id: '',
        lastModifiedDate: '',
        name: ''
    };
    @Output() completed = new EventEmitter<string>();
    loading = false;
    siteGroupForm: FormGroup | undefined;
    private _currentProcess: Subscription = new Subscription();

    constructor(
        private readonly logger: NGXLogger,
        private groupService: GroupService
    ) {}

    ngOnInit(): void {
        this.siteGroupForm = new  FormGroup({
            siteGroupName: new FormControl(this.siteDetails?.name),
            siteGroupId: new FormControl(this.siteDetails?.id)
        });
    }

    onSiteGroupUpdateSubmit(): void {
        this.upsertSiteGroup();
    }

    private upsertSiteGroup(): void {
        this.loading = true;
        this.logger.debug('[GroupSiteUpdateComponent] Updating existing site-and-project group: ' + this.siteGroupForm?.value.siteGroupId);
        this._currentProcess = this.groupService.upsertSiteGroup(
            this.siteGroupForm?.value.siteGroupName,
            this.siteGroupForm?.value.siteGroupId
        ).subscribe(newSiteGroup => {
            this.logger.debug('[GroupSiteUpdateComponent] Site group updated successfully: ' + newSiteGroup.id);
            this.completed.emit('updated');
            this.loading = false;
        }, (error: any) => {
            this.logger.debug('[GroupSiteUpdateComponent] Site group failed to update');
            this.logger.error(error);
            this.loading = false;
        });
    }

    onUpdate(update: boolean) {
        if (update) {
            this.completed.emit('update');
        }
    }

    onCancel(): void {
        this.logger.debug('[GroupSiteUpdateComponent] Update Site Group Modal Cancelled');
        this.completed.emit('cancelled');
    }

    ngOnDestroy(): void {
        this._currentProcess.unsubscribe();
    }
}
